export default __webpack_public_path__ + "static/media/Nose.3fe7315f.PNG";